// Auto-generated entry for blockHotelOverview.cshtml

import 'mapbox-gl/dist/mapbox-gl.css';
import '@/styles/Global/Controls/ControlHotelOverview.scss';
import '@/scripts/Controls/control.hotel-overview.js';

import mapboxgl from 'mapbox-gl';

// expose global for legacy scripts that expect `window.mapboxgl`
(window as any).mapboxgl = mapboxgl;
